import { Box, Stack } from '@mui/material';
import React, { useEffect, useState } from 'react';
import HisMailingFilter from './HisMailingFilter';
import HisMailingTable from './HisMailingTable';
import HisMailingPagination from './HisMailingPagination';
import ShowContentWitchEmpty from '../../../components/material-ui/show_content_empty/ShowContentWitchEmpty';
import { mockMailingHistory } from '../../../enums/mock';
import { postOptions, TEST_MODE } from '../../../enums/enums';
import { API_MAILING } from '../../../api/mailing';

export default function HistoryMailingContent() {
  const [loader, setLoader] = useState(false);
  const [emptyFill, setEmptyFill] = useState(false);
  const [mailings, setMailings] = useState([]);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(postOptions[1].value);
  const [filter, setFilter] = useState({});

  const onFilterClick = (data) => {
    if (TEST_MODE) {
      setMailings(mockMailingHistory);
      return;
    }

    setLoader(true);

    const newFilter = { ...filter, pageNo, pageSize, ...data };
    if (newFilter.managerId === 'skip') newFilter.managerId = null;

    API_MAILING.list
      .history(newFilter)
      .then((e) => {
        const data = e.data.data;
        const records = data.records;

        setFilter({ ...newFilter, pageCount: data.pageCount, pageNo: data.pageNo });
        setPageNo(data.pageNo);
        setEmptyFill(!records.length);
        setMailings(records);
      })
      .catch(console.error)
      .finally(() => setLoader(false));
  };

  return (
    <Stack gap={5} height={'100%'}>
      <HisMailingFilter onFilterClick={onFilterClick} />
      <ShowContentWitchEmpty
        loader={loader}
        condition={mailings.length}
        conditionPlug={emptyFill}
        plugText="There have been no mailings yet"
        isBox
        plugContainerSx={{ mt: 7 }}>
        <Stack gap={1}>
          <HisMailingTable mailings={mailings} />
          <HisMailingPagination
            pageCount={filter.pageCount || 0}
            pageNo={pageNo}
            pageSize={pageSize}
            setPageNo={setPageNo}
            setPageSize={setPageSize}
            onFindClick={onFilterClick}
          />
        </Stack>
      </ShowContentWitchEmpty>
    </Stack>
  );
}
